import { Company } from "./company";

export class Person {
  id: number;
  name: string;
  idType: IdType;
  identification: string;
  company: Company;
  phoneNumber: string;
  email: string;
  carDetail: string;
  checkIn: number;
  checkOut: number;
  duration: string;
  otherCompanyName: string;
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/person.ts